import React, {useEffect, useState} from 'react';
import {Button, Card, Link, Text, TextField, Toast} from "@shopify/polaris";
import {useDispatch, useSelector} from "react-redux";
import {ApiCall} from "../../helper/axios";
import {updateModalStatus} from "../../redux/slice/commonSlice";

const StoreIntegration = ({email}) => {
    const {shop_data,token} = useSelector((store) => store.commonData.store_data);
    const dispatch = useDispatch();
    const [appEmbeddedUrl, setAppEmbeddedUrl] = useState('');
    const [htmlWithCurrencyText, setHtmlWithCurrecnyText] = useState("<span class=money>Rs. {{amount}}</span>");
    const [activeToast, setActiveToast] = useState(false);
    const [saveLoader, setSaveLoader] = useState(false);
    const [activeToastMessage, setActiveToastMessage] = useState('');
    const toggleActive = () => {setActiveToast((activeToast) => !activeToast)};
    const toastMarkup = activeToast ? (
        <Toast content={activeToastMessage} onDismiss={toggleActive} />
    ) : null;

    useEffect(() => {
        if(shop_data?.money_format){
            if(shop_data?.money_format?.includes('span') && shop_data?.money_format?.includes('money')){
                setHtmlWithCurrecnyText(shop_data?.money_format)
            }else{
                setHtmlWithCurrecnyText(`<span class=money>${shop_data?.money_format}</span>`)
            }
            setAppEmbeddedUrl(`https://${shop_data.store_name}/admin/themes/current/editor?context=apps&appEmbed=${process.env.EXTENSION_UUID}/${process.env.EXTENSION_BLOCK_NAME}`)
        }
    },[shop_data])

    const copytoClipboardFn = () => {
        navigator.clipboard.writeText(htmlWithCurrencyText);
        setActiveToast(true)
        setActiveToastMessage("Copied Successfully!");
    }

    const validateIntegrationFn = async () => {
        setSaveLoader(true);
        const enableDisableAppStatus = await ApiCall('POST', '/validate-integration', {}, { authentication: token });
        if(enableDisableAppStatus?.data?.statusCode === 200 && enableDisableAppStatus?.data?.data){
            setActiveToast(true)
            setActiveToastMessage("Valid Successfully!");
            dispatch(updateModalStatus(false));
        }else{
            setActiveToast(true)
            setActiveToastMessage("Not Valid!");
            dispatch(updateModalStatus(true));
        }
        setSaveLoader(false);
    }

    return (
        <>
            <Card>
                <Text as="h2" variant="headingSm">
                    Store Integration
                </Text>
                <ul className="store-integration-ul">
                    <li>
                        <Text fontWeight="regular" variant="headingMd" as="h6">
                            Navigate to Shopify <Link  url={`https://${shop_data.store_name}/admin/settings/general`} external>Admin Panel -> Settings -> Store Defaults</Link>
                        </Text>
                    </li>
                    <li>
                        <Text fontWeight="regular" variant="headingMd" as="h6">
                            In Currency Display, click on three dots in the right corner
                        </Text>
                    </li>
                    <li>
                        <Text fontWeight="regular" variant="headingMd" as="h6">
                            Click on Change Currency Formatting
                        </Text>
                    </li>
                    <li>
                        <Text fontWeight="regular" variant="headingMd" as="h6">
                            Update HTML with currency field with the below value
                        </Text>
                        <div className="store-integration-html-with-currency-div">
                            <TextField
                                label="HTML with currency"
                                placeholder="Default"
                                readOnly
                                value={htmlWithCurrencyText}
                                suffix={
                                    <>
                                        <div onClick={copytoClipboardFn} style={{display:"flex",alignItems:"center",cursor:"pointer",color:"var(--p-color-text-link)"}}> <span>Copy</span> </div>
                                    </>
                                }
                                autoComplete="off"/>
                        </div>
                    </li>
                    <li>
                        <Text fontWeight="regular" variant="headingMd" as="h6">
                            Update HTML without currency field with the below value
                        </Text>
                        <div className="store-integration-html-with-currency-div">
                            <TextField
                                label="HTML without currency"
                                placeholder="Default"
                                readOnly
                                value={htmlWithCurrencyText}
                                suffix={
                                    <>
                                        <div onClick={copytoClipboardFn} style={{display:"flex",alignItems:"center",cursor:"pointer",color:"var(--p-color-text-link)"}}> <span>Copy</span> </div>
                                    </>
                                }
                                autoComplete="off"/>
                        </div>
                    </li>
                    <li>
                        <Text fontWeight="regular" variant="headingMd" as="h6">
                            Click on Save button in the Shopify page
                        </Text>
                    </li>
                    <li>
                        <Text fontWeight="regular" variant="headingMd" as="h6">
                            Go to <Link url={appEmbeddedUrl} external>App Embeds Block</Link> and click on Save button in top right corner.
                        </Text>
                    </li>
                </ul>
                <div className="store-integration-message-div">
                    <Text fontWeight="regular" variant="headingMd" as="h6">
                        If you encounter any issues, feel free to email us at <Link url={`mailto:${email}`}>{email}</Link>, and we will get back to you within 24 hours.
                    </Text>
                </div>

                <div className="store-integration-message-div" style={{justifyContent:"end"}}>
                    <Button onClick={validateIntegrationFn} loading={saveLoader} size="large" variant="primary">Validate this integration</Button>
                </div>
                {toastMarkup}
            </Card>
            <br/>
        </>
    );
};

export default StoreIntegration;
